import {
    Breadcrumb,
    Button,
    Card,
    Checkbox,
    Col,
    Divider,
    Drawer,
    Dropdown,
    Empty,
    Flex,
    Form,
    Input,
    Layout,
    message,
    Popconfirm,
    Radio,
    Row,
    Select,
    Steps,
    Table,
    Tag,
    Menu,
    theme,
    Tour,
    Typography,
    notification,
} from 'antd';
import {
    FilterOutlined,
    HomeOutlined,
    CopyOutlined,
    DeleteOutlined,
    EyeOutlined,
    EditOutlined,
    FileWordOutlined,
    AppstoreOutlined,
    MoreOutlined,
} from '@ant-design/icons';
import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react';
import PaymentInvoice from './PaymentInvoice';
import Templates from '../../../helperComponents/Templates';
import RequestApproval from '../../../restAPI/RequestApproval';
import { useSelector } from 'react-redux';
import SelectedTemplate from './SelectedTemplate';
import dayjs from 'dayjs';
import CommonSkeletonLoader from '../../../helperComponents/CommonSkeleton';

const { Search, TextArea } = Input;
const { Option } = Select;
const { Text } = Typography;

const TemplateView = forwardRef(({ setData, savedData }, ref) => {
    const ref1 = useRef(null);
    const childref = useRef(null);
    const childrefMakeCopy = useRef(null);
    const notselectedMakeCopy = useRef(null);
    const editTemplateRef = useRef(null);
    const [openTour, setOpenTour] = useState(true);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [openNewDrawer, setOpenNewDrawer] = useState(false);
    const [openMakeCopyDrawer, setOpenMakeCopyDrawer] = useState(false);
    const [openMakeCopyDrawerNotSelected, setOpenMakeCopyDrawerNotSelectedr] = useState(false);
    const [selectedEditTemplate, setSelectedEditTemplate] = useState(null);
    const [openEditDrawer, setOpenEditDrawer] = useState(false);
    //  const [templateState,setTemplateState] = useState();
    const [myTemplates, setMyTemplstes] = useState([]);
    const [myTemplatesV2, setMyTemplstesv2] = useState([]);
    const [selectedValue, setSelectedValue] = useState(null);
    const [prevSelectedValue, setPrevSelectedValue] = useState(null);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [makeaCopyTemplate, setMakeaCopyTemplate] = useState(null);
    const [prevTemplate, setPrevTemplate] = useState(null);
    const [searchTemplateValue, setSearchTemplateValue] = useState("");

    const [templateViewState, setTemplateViewState] = useState(null)

    const [isTemplatesLoading, setIsTemplatesLoading] = useState(false);

    const {
        token: {
            colorBgContainer,
            borderRadiusLG,
            colorPrimary,
            colorPrimaryBorder,
            colorTextDescription,
            fontSizeSM,
        },
    } = theme.useToken();

    const { companyId, token, userCompany } = useSelector(state => state.auth);
    RequestApproval.testWithJWTandCID(companyId, token);

    useEffect(() => {
        getMyTemplates();
        setSelectedTemplate(savedData);
        setTemplateViewState(savedData);
    }, []);

    const getMyTemplates = () => {
        setIsTemplatesLoading(true);
        const data = RequestApproval.getTemplates().then((data) => {
            setMyTemplstes(data.data);
            setMyTemplstesv2(data.data);
            setIsTemplatesLoading(false);
        }).catch(() => {
            setIsTemplatesLoading(false);
        });
    }

    useImperativeHandle(ref, () => ({
        saveTemplateView() {
            setData(templateViewState);
            return { status: true, res: templateViewState }
        }
    }));

    const [api, contextHolder] = notification.useNotification();
    const openNotification = (type, message, description, placement) => {
      api[type]({
        message: message,
        description: description,
        placement
      });
    };

    const items = [
        {
            label: ' Make A Copy',
            key: '0',
            icon: <CopyOutlined />,
            onClick: () => {
                showDrawerMakeCopy();
            },
        },
        {
            label: 'Remove',
            key: '1',
            icon: <DeleteOutlined />,
            onClick: () => {
                setSelectedTemplate(null);
                setSelectedValue(null);
                setTemplateViewState(null);

            },
        },
    ];

    const showDrawer = () => {
        getMyTemplates();
        setOpenDrawer(true);
    };

    const showDrawerMakeCopy = () => {
        setOpenMakeCopyDrawer(true);
    };
    const closeDrawer = () => {
        setOpenDrawer(false);
        setSearchTemplateValue("");
        setMyTemplstes(myTemplatesV2);

        const prev = { ...prevTemplate }
        const prevselect = { ...prevSelectedValue }

        if (selectedTemplate == null) {
            // setPrevSelectedValue(prevselect)
            setSelectedValue(null);
        }
        else {
            setSelectedValue(prevSelectedValue);
        }


        // setSelectedValue(null);
    };
    const addTemplate = () => {
        let selectedTem = null
        myTemplates.forEach(template => {
            if (template._id === selectedValue) {
                selectedTem = template;
            }
        });

        setSelectedTemplate(selectedTem);
        // closeDrawer(selectedTem);
        setOpenDrawer(false);
        setSearchTemplateValue("");
        setMyTemplstes(myTemplatesV2);
        // console.log(selectedTem,"selectedValue");
    }

    const handleSelectionChange = (e) => {

        if (selectedValue == null) {
            setPrevSelectedValue(e.target.value)
        } else {
            setPrevSelectedValue(selectedValue)

        }

        setSelectedValue(e.target.value); // Update state with selected value
    };

    const showNewDrawer = () => {
        setOpenNewDrawer(true);
        setOpenDrawer(false);
    };

    const closeNewDrawer = () => {
        //       console.log('templatesave',templateState);
        if (childref.current) {
            childref.current.clearTemplateState();
        }


        setOpenNewDrawer(false);
        showDrawer();
    };

    const closeNDrawerMakeCopy = () => {
        if (childrefMakeCopy.current) {
            childrefMakeCopy.current.clearTemplateState();
        }
        setOpenMakeCopyDrawer(false);
    }

    const closeDrawerMakeCopynotSelected=()=>{
        if (notselectedMakeCopy.current) {
            notselectedMakeCopy.current.clearTemplateState();
        }
        setOpenMakeCopyDrawerNotSelectedr(false);
    }

    const steps = [
        {
            title: 'Action',
            description: 'You can edit or delete an existing template by clicking the button.',
            target: () => ref1.current,
            placement: 'top',
        },
    ];

    const handleSaveButton = async() => {
        let st =await childref.current.validateAndSaveTemplate();
        if(st){
            getMyTemplates()
        }
        
    };
    const handleSaveButtonMakeCopy = async() => {
        let st =await childrefMakeCopy.current.validateAndSaveTemplate();
        if(st){
            getMyTemplates()
        }
    }
    const handleSaveButtonMakeCopyNotselect = async() => {
        let st =await notselectedMakeCopy.current.validateAndSaveTemplate();
        if(st){
            getMyTemplates()
        }
    }

    const searchTemplate = (e) => {
        let searchvalue = e.target.value.replace(/^\s+/, "").toLowerCase();
        let regex = new RegExp(`${searchvalue}`);
        setSearchTemplateValue(searchvalue);
        const data = myTemplatesV2.filter(element => regex.test(element.name.toLowerCase()));
        setMyTemplstes(data);
        // console.log(searchvalue,"searched value");
        // const data = 

    }

    const deleteTemplatebyId=async(item)=>{
        await RequestApproval.deletetemplateById(item._id)
        .then((response) => {
            // message.success('Remove Template Successfully!');
            openNotification('success', 'Success', `Remove Template Successfully !`, 'bottomLeft');

            getMyTemplates();
        })
        .catch((err) => {
        if (err.response) {
            // message.error(`${err.response.data.message}`);
            openNotification('error', 'Error', `${err.response.data.message}`, 'bottomLeft');
            
        } else {
            // message.error('Remove Template Failed!');
            openNotification('error', 'Error', `Remove Template Failed!`, 'bottomLeft');
        }
        });
    }

    const showEditDrawer = () => {
        setOpenEditDrawer(true);
    };
    const closeEditDrawer =()=>{
        setOpenEditDrawer(false);
    }
    const saveEditTemplate = async() => {
        await editTemplateRef.current.validateAndSaveTemplate();

        getMyTemplates();
        //setForceRender(forceRender+1)
    }
    return (
        <>
        {contextHolder}
            <Card
                bordered={false}
                title="Template"
                extra={
                    <Button
                        type="primary"
                        icon={<AppstoreOutlined />}
                        onClick={showDrawer}
                    >
                        Select Template
                    </Button>
                }
            >

                {selectedTemplate !== null ?
                    <>
                        <Flex align="center" justify="space-between" gap={24}>
                            <Text strong>{selectedTemplate.name}</Text>
                            <Dropdown
                                menu={{
                                    items,
                                }}
                                trigger={['click']}
                            >
                                <a onClick={(e) => e.preventDefault()}>
                                    <Button icon={<MoreOutlined />} ref={ref1} />
                                </a>
                            </Dropdown>
                        </Flex>
                        <Divider />

                        <SelectedTemplate key={selectedTemplate._id} setTemplateViewsate={setTemplateViewState} template={selectedTemplate} />
                        {/* <PaymentInvoice /> */}
                    </>
                    :
                    <>
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={
                                <Text>You Need to Select a Template</Text>
                            } />
                    </>

                }

            </Card>

            <Tour
                open={openTour}
                onClose={() => setOpenTour(false)} // Only close the Tour
            // steps={steps}
            />

            {openDrawer ?
                <>
                    <Drawer
                        title="Template Manager"
                        onClose={closeDrawer} // Close only the Drawer
                        open={openDrawer}
                        size="large"
                        // destroyOnClose={true}
                        footer={[
                            <Flex justify="flex-end" align="center" gap="large" key="drawer-footer">
                                <Button onClick={closeDrawer}>Cancel</Button>
                                <Button onClick={addTemplate} type="primary">Add</Button>
                            </Flex>,
                        ]}
                        extra={
                            <Button type="primary" onClick={showNewDrawer}>
                                Create New
                            </Button>
                        }
                    >
                        <Form layout="vertical">
                            <Form.Item>
                                <Input onChange={searchTemplate} value={searchTemplateValue} placeholder="Search template name here" />
                            </Form.Item>
                            {isTemplatesLoading ? (<CommonSkeletonLoader />) : (<>
                                {myTemplates.length !== 0 ? (
                                    <>
                                        <Radio.Group  onChange={handleSelectionChange} value={selectedValue} style={{ width: 'calc(100% - 48px)' }}>
                                            {myTemplates.map((item, index) => {
                                                const menuItems = [
                                                    {
                                                        label: 'Make A Copy',
                                                        key: '2',
                                                        icon: <CopyOutlined />,
                                                        onClick: () => {
                                                            setOpenMakeCopyDrawerNotSelectedr(true);
                                                            setMakeaCopyTemplate(item);
                                                        },
                                                    },
                                                    {
                                                        label: 'Edit',
                                                        key: '1',
                                                        icon: <EditOutlined />,
                                                        onClick: () => {
                                                            // setSelectedTemplate(null);
                                                            // setSelectedValue(null);
                                                            showEditDrawer();
                                                            setSelectedEditTemplate(item);

                                                        },
                                                    },
                                                    {
                                                        label: 'Remove',
                                                        key: '3',
                                                        icon: <DeleteOutlined />,
                                                        onClick: () => {
                                                            deleteTemplatebyId(item)
                                            
                                                        },
                                                    }
                                                ];
                                                return(
                                                    <Flex
                                                        key={index}
                                                        gap={16}
                                                        align="center"
                                                        justify="space-between"
                                                        style={{
                                                            padding: '16px 24px',
                                                            cursor: 'pointer',
                                                            marginBottom: '16px',
                                                            background: colorBgContainer,
                                                            borderRadius: borderRadiusLG,
                                                            width: '100%'
                                                        }}
                                                    >
                                                        <Flex gap={16} justify="flex-start">
                                                            <Radio value={item._id} ></Radio>
                                                            <Flex gap={4} vertical justify="flex-start">
                                                                <Text strong>{item.name}</Text>
                                                                <Text style={{ color: colorTextDescription }}>
                                                                    {dayjs(item.created_at).format('MMMM D, YYYY')}
                                                                </Text>
                                                            </Flex>
                                                        </Flex>
                                                        <Dropdown
                                                            menu={{ items: menuItems }}
                                                            trigger={['click']}
                                                        >
                                                            <a onClick={(e) => e.preventDefault()}>
                                                                <Button icon={<MoreOutlined />} />
                                                            </a>
                                                        </Dropdown>
                                                    </Flex>
                                                )
                                                
                                            })
                                            }
                                        </Radio.Group>
                                    </>) : (<Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description={
                                            <Text>No Templates to show</Text>
                                        } />)
                                }
                            </>)}
                            {/* List items repeated 5 times */}
                        </Form>
                    </Drawer>
                </> : <></>

            }


            <Drawer
                title="Create New Template"
                onClose={closeNewDrawer}
                open={openNewDrawer}
                destroyOnClose={true}
                size="large"
                width={'100%'}
                footer={[
                    <Flex justify='flex-end' align='center' gap='large'>
                        <Button onClick={closeNewDrawer}>
                            Cancel
                        </Button>
                        <Button
                            onClick={handleSaveButton}
                            type="primary"
                        >
                            Save
                        </Button>
                    </Flex>
                ]
                }
            >
                <Templates ref={childref} drawerclose={closeNewDrawer} initialData={null} creationType={"new"} />
            </Drawer>

            {openMakeCopyDrawer ?
                <>
                    <Drawer
                        title="Make Update Template"
                        onClose={closeNDrawerMakeCopy}
                        open={openMakeCopyDrawer}
                        destroyOnClose={true}
                        size="large"
                        width={'100%'}
                        footer={[
                            <Flex justify='flex-end' align='center' gap='large'>
                                <Button onClick={closeNDrawerMakeCopy}>
                                    Cancel
                                </Button>
                                <Button
                                    onClick={handleSaveButtonMakeCopy}
                                    type="primary"
                                >
                                    Save
                                </Button>
                            </Flex>
                        ]
                        }
                    >
                        <Templates ref={childrefMakeCopy} drawerclose={closeNDrawerMakeCopy} initialData={selectedTemplate} creationType={"makecopy"} />
                    </Drawer>
                </> : <></>

            }
            {openMakeCopyDrawerNotSelected ?
                <>
                    <Drawer
                        title="Make Update Template"
                        onClose={closeDrawerMakeCopynotSelected}
                        open={openMakeCopyDrawerNotSelected}
                        destroyOnClose={true}
                        size="large"
                        width={'100%'}
                        footer={[
                            <Flex justify='flex-end' align='center' gap='large'>
                                <Button onClick={closeDrawerMakeCopynotSelected}>
                                    Cancel
                                </Button>
                                <Button
                                    onClick={handleSaveButtonMakeCopyNotselect}
                                    type="primary"
                                >
                                    Save
                                </Button>
                            </Flex>
                        ]
                        }
                    >
                        <Templates ref={notselectedMakeCopy} drawerclose={closeDrawerMakeCopynotSelected} initialData={makeaCopyTemplate} creationType={"makecopy"} />
                    </Drawer>
                </> : <></>

            }
            <Drawer
                title="Edit Template"
                onClose={closeEditDrawer}
                open={openEditDrawer}
                size="large"
                destroyOnClose={true}
                width={'100%'}
                footer={[
                    <Flex justify='flex-end' align='center' gap='large'>
                        <Button onClick={closeDrawer}>
                            Cancel
                        </Button>
                        <Button
                            onClick={saveEditTemplate}
                            type="primary"
                        >
                            Save
                        </Button>
                    </Flex>
                ]
                }
            >
                {/* <Templates /> */}
                {selectedEditTemplate ? <>
                    <Templates ref={editTemplateRef} drawerclose={closeEditDrawer} initialData={selectedEditTemplate} creationType={"edit"} />
                </> : <></>}
            </Drawer>

        </>
    );
});

export default TemplateView